// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"ffb97747","453":"4cbecd4a"}[chunkId] + ".chunk.js";
};